import React, {Component, Fragment} from 'react';
import style from '../css/lockedBet.css';
import {connect} from 'react-redux';
// helpers
import {roundNumber} from '../../../helpers/mathFunctions';
import {getFormattedCurrency, getText, usingNonDecimalCurrency} from '../../../helpers/localization';
// import {hasEventTypeRacerNumberUI} from '../modules/racing/helpers/racersHelper';
// constants
// import {ASSETS_URL} from '../../../constants/endpoints';
// import {VIRTUALS} from '../../../constants/games';
import {BASE_VALUE} from '../../../constants/chips';
import {getOddsFromOddsType} from "../../../helpers/oddsHelpers";
import {getModuleFromEventType} from './../../../helpers/moduleHelpers';
import {JPY, MATCHDAY_MODULE, RACING_MODULE} from '../../../constants/identifiers';
import {getPotentialReturn, isMatchDay, isWinningBet} from "../modules/matchday/helpers/matchdayHelper";
import {ASSETS_URL} from "../../../constants/endpoints";
import {calculateTimeDifference} from '../../../helpers/helperFunctions';
import {getGameByChannel} from '../helpers/gameHelpers';
import {OPERATOR} from '../../../constants/operator';
import { isBaseBall } from '../modules/baseball/helpers/marketHelpers';

const mapStateToProps = (state, ownProps) => {
    return {selectedOddsType: state.vpp.selectedOddsType, serverTimeOffset: state.vpp.serverTimeOffset, systemLanguage: state.vpp.systemLanguage};
};

class LockedBet extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            isEventDetailsVisible: false,
            selectedOddsType: storeData.vpp.selectedOddsType,
            serverTimeOffset: storeData.vpp.serverTimeOffset,
            systemLanguage: storeData.vpp.systemLanguage
        };

    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                selectedOddsType: storeData.vpp.selectedOddsType,
                serverTimeOffset: storeData.vpp.serverTimeOffset,
                systemLanguage: storeData.vpp.systemLanguage
            });
        }
    }
    
    _isEmptyGameCycleId(gameCycleId){
        return gameCycleId === undefined || gameCycleId === "";
    }
    render() {
        // let eventType = this.props.betSelection.Bets[0].EventType;
        let systemCurrency = this.props.store != undefined ? this.props.store.getState().vpp.systemCurrency : '';
        let stake = usingNonDecimalCurrency(systemCurrency) ? this.props.betSelection.Bets[0].Stake : roundNumber(this.props.betSelection.Bets[0].Stake / BASE_VALUE, 2);
        let stakeUI;

        let gameCycleId = this.props.betSelection.Bets[0].GameCycleId;
        let gameCycleIdUI = OPERATOR.gameCycleIdEnabled &&  !this._isEmptyGameCycleId(gameCycleId) ? (<div className={style.gameCycleId}>
            ID: {gameCycleId}
        </div>) : '';

        // format currencies
        stakeUI = getFormattedCurrency(this.props.store, stake);

        let lockedBetContainerCustomStyle = ''

        let bottomContainer;
        let placeHolderUI;
        let returnsUI;
        let outcomeUI;
        let eventDetailsUI;
        let eventDetailsArrow = this.props.isSettledBet && !this.props.voidStatus && this.props.eventDetails
            ? (<div className={style.eventDetailsArrowAndTextContainer}>
                    <div className={style.eventDetailsArrowContainer}>
                        <div
                            className={this.state.isEventDetailsVisible ? style.eventDetailsArrowDown : style.eventDetailsArrowRight}/>
                    </div>
                    <div className={style.eventDetailsText}>{getText('DETAILS', this.props.store)}</div>
                </div>
            )
            : null;

        let matchdayBetAmounts  = '';
        if (isMatchDay(this.props.betSelection.Bets[0].EventType) && !this.props.isSettledBet && calculateTimeDifference(this.props.betSelection.Bets[0].EventTime, new Date(Date.now() - this.state.serverTimeOffset)) > 0) {
           if (!this.props.voidStatus) {
            matchdayBetAmounts =style.matchdayBetAmounts;
            }
        }

        let prizeNumber;
        if (this.props.isSettledBet) {
            prizeNumber = usingNonDecimalCurrency(systemCurrency) ? this.props.betSelection.Bets[0].Prize : (this.props.prize === undefined ? roundNumber(this.props.betSelection.Bets[0].Prize / BASE_VALUE, 2) : this.props.prize);
            let outcomeText = prizeNumber > 0 ? getText('WON', this.props.store) : getText('LOST', this.props.store);

            let prize = getFormattedCurrency(this.props.store, prizeNumber);

            returnsUI = (
                <div className={style.returningsContainer}>
                    <div
                        className={style.actualReturnsLabel}>{this.props.voidStatus ? getText('REFUNDED', this.props.store) : getText('RETURNED', this.props.store)}
                    </div>
                    <div id={'returned_value_' + this.props.index}
                         className={this.props.voidStatus ? style.actualReturnsTextVoided : style.actualReturnsText}>{this.props.voidStatus ? stakeUI : prize.toString()}</div>
                </div>
            );

            outcomeUI = (
                <div
                    className={`${style.outcomeContainer} ${(prizeNumber > 0 && !this.props.voidStatus)
                        ? style.won
                        : ''}`}>{this.props.voidStatus ? getText('VOIDED', this.props.store) : outcomeText}</div>
            );

            placeHolderUI = (<div className={style.placeHolderContainer}>{eventDetailsArrow}</div>);

            eventDetailsUI = (<div className={style.eventDetailsContainer}>
                {this.state.isEventDetailsVisible ? this.props.eventDetails : null}
            </div>);
        } else {
            let potentialReturns;
            if (this.props.potentialReturns !== undefined) {
                potentialReturns = usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency) ? Math.round(this.props.potentialReturns) : this.props.potentialReturns;
                potentialReturns = (this.props.store.getState().vpp.systemCurrency.toUpperCase() === JPY ) ? String.fromCharCode(165) + potentialReturns : potentialReturns;
            } else {
                potentialReturns = getFormattedCurrency(this.props.store, 0);

                if (Number(stake) && Number(this.props.odd)) {
                    potentialReturns = getPotentialReturn(this.props.odd, stake, 1, 0,this.props.betSelection.PromoId === "real_bet" ? 0 : stake);

                    if (usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency)) {
                        potentialReturns = Math.round(potentialReturns);
                    }

                    potentialReturns = getFormattedCurrency(this.props.store, potentialReturns);
                }
            }

            returnsUI = (
                <div className={style.returningsContainer}>
                    <div className={style.potentialReturnsLabel}>{getText('POT_RETURNS', this.props.store)}</div>
                    <div id={'potential_returns_value_' + this.props.index}
                         className={`${style.potentialReturnsText} ${matchdayBetAmounts}`}>{potentialReturns.toString()}</div>
                </div>
            );

        }

        bottomContainer = (
            <div
                className={this.props.isSettledBet && !this.props.voidStatus ? style.settledBetBottomContainer : style.bottomContainer}
                onClick={() => eventDetailsArrow !== null ? this.setState({
                    ...this.state,
                    isEventDetailsVisible: !this.state.isEventDetailsVisible
                }) : ''}>
                {placeHolderUI}
                {outcomeUI}
                {returnsUI}
            </div>
        );
        let eventInfo;
        if (this.props.betSelection.Bets[0].EventType !== undefined) {
            switch (getModuleFromEventType(this.props.betSelection.Bets[0].EventType)) {
                case RACING_MODULE:
                    eventInfo = (<div className={style.event}
                                      id={'eventName_' + this.props.index}>{`${this.props.eventName.dayMonthYear}  ${this.props.eventName.hoursMinutes} `}</div>)
                    break;
                case MATCHDAY_MODULE:
                    score = this.props.eventName.score ? this.props.eventName.score : this.props.eventName.gameTitle;
                    eventInfo = (<Fragment>
                        <div className={style.event}
                             id={'eventDate_' + this.props.index}>{`${this.props.eventName.dayMonthYear}  ${this.props.eventName.hoursMinutes}  ${getText('MD', this.props.store, [this.props.leagueDay])}`}</div>
                        <div className={style.event} id={'eventName_' + this.props.index}>{`${score}`}</div>
                    </Fragment>)
                    break;
                default:
                    let score = this.props.eventName.score ? this.props.eventName.score : this.props.eventName.gameTitle;
                    eventInfo = (<Fragment>
                        <div className={style.event}
                             id={'eventDate_' + this.props.index}>{`${this.props.eventName.dayMonthYear}  ${this.props.eventName.hoursMinutes} `}</div>
                        <div className={style.event} id={'eventName_' + this.props.index}>{`${score}`}</div>
                    </Fragment>)
                    break;
            }
        }
        let names;
        if (this.props.names && this.props.names.length > 0) {
            names = this.props.names.map((name, index) => {
                return (
                    <div key={index} id={'name_' + this.props.index + '_' + index} className={style.name}>{name}</div>);
            });
        }
        let winLoseBand = '';
        let winLoseStyle = '';
        if (prizeNumber !== undefined) {
            if (prizeNumber > 0 && !this.props.voidStatus) {
                winLoseBand = style.win;
            } else if (!this.props.voidStatus) {
                winLoseBand = style.lose;
            }
        }

        //delete create logic for color
        let isPromoBet = false;
        if(!(this.props.betSelection.PromoId === "real_bet")){
            lockedBetContainerCustomStyle = `${style.lockedBetContainerPromo}  ${style.lockedBetContainerPromoShadow}`;
            isPromoBet = true;
        } else{
            lockedBetContainerCustomStyle = style.lockedBetContainer;
        }

        let matchdayBetType = '';
        let matchdayEventName = '';
        if (isMatchDay(this.props.betSelection.Bets[0].EventType) && !this.props.isSettledBet && calculateTimeDifference(this.props.betSelection.Bets[0].EventTime, new Date(Date.now() - this.state.serverTimeOffset)) > 0) {
            let game = this.props.store.getState().vpp.games.find(game => game.channel === this.props.betSelection.Bets[0].Channel);
            let isWin = isWinningBet(this.props.betSelection.Bets[0], game.goalTimings, this.state.serverTimeOffset);
            if (!this.props.voidStatus) {
                if (isWin)
                    {winLoseStyle = style.winBackground;
                    lockedBetContainerCustomStyle = style.lockedBetContainerPromo;}
                else
                    {winLoseStyle = style.loseBackground;
                    lockedBetContainerCustomStyle = style.lockedBetContainerPromo;}

            matchdayBetType = style.matchdayBetType;
            matchdayEventName = style.matchdayEventName;
            }
        }

        let odd = getOddsFromOddsType(this.props.odd, this.state.selectedOddsType);
        let betFooter = !this.props.isSettledBet ? bottomContainer : '';
        let betDetails = this.props.isSettledBet ? bottomContainer : '';

        let game = getGameByChannel(this.props.store, this.props.betSelection.Bets[0].Channel);
        let gameNameDiv = isMatchDay(this.props.betSelection.Bets[0].EventType) ? (
                <div
                    className={`${style.eventName} ${matchdayEventName}` }>{getText((game.gameCategory + '_' + game.name).replace(/\s+/g, '_'), this.props.store)}
                    <img className={style.betSlipImg} src={`${ASSETS_URL}${game.assetsPath}/betslipIcon.png`}/>
                </div>
            ) :isBaseBall(this.props.betSelection.Bets[0].EventType)?(<div
                className={style.eventName}>{getText((game.gameCategory + '_' + game.name).replace(/\s+/g, '_')+"_SHORT", this.props.store)}</div>):
            (<div
                className={style.eventName}>{getText((game.gameCategory + '_' + game.name).replace(/\s+/g, '_'), this.props.store)}</div>);

        return (
            <div className={`${lockedBetContainerCustomStyle} ${winLoseBand} ${winLoseStyle} `}>
                <div className={style.topContainer}>
                    <div className={style.leftContainer}>
                        <div className={`${style.betType} ${matchdayBetType} ${style.betTypeHeading}`} id={'betType_' + this.props.index}>{this.props.betType}</div>
                        <div className={style.names}>{names}</div>
                        {eventInfo}
                    </div>
                    {/*<div className={style.centerContainer}>{silks}</div>*/}
                    <div className={style.rightContainer}>
                        {gameNameDiv}
                        <div className={style.oddContainer}>
                            <div className={style.oddLabel}>{`${getText('ODDS', this.props.store)}: `}</div>
                            <div className={`${style.odd} ${matchdayBetAmounts}`} id={'odd_' + this.props.index}>{odd}</div>
                        </div>
                        <div className={style.stakeContainer}>
                            {isPromoBet && <div className={style.giftIconBox}>
                                <img className={style.giftIconImage} src={`${ASSETS_URL}promo/giftIconWhite.png`} alt='gift' />
                            </div>}
                            <div className={style.stakeLabel}>{`${getText('STAKE', this.props.store)}: `}</div>
                            <div className={`${style.stake} ${matchdayBetAmounts}`}>{stakeUI}</div>
                        </div>
                        {betFooter}
                    </div>
                </div>
                {gameCycleIdUI}
                {betDetails}
                {eventDetailsUI}
            </div>
        );
    }
}

export default connect(mapStateToProps)(LockedBet);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/lockedBet.js